// extracted by mini-css-extract-plugin
module.exports = {"inputDiv":"shareModal_inputDiv__rqexa","inputPicDiv":"shareModal_inputPicDiv__wDZnR"};